import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { ButtonSize } from "common/components/button/constants";
export function template() {
  const sections = this.attr(`sections`);
  const sectionsWithItems = [...sections].filter((section) => {
    var _a;
    return ((_a = section.items) == null ? void 0 : _a.length) > 0;
  });
  if (sectionsWithItems.length === 1) {
    const section = sectionsWithItems[0];
    const [allOption, ...restOptions] = section.items;
    if (restOptions.length < 2) {
      return /* @__PURE__ */ jsx("div", {
        sel: ".single-option"
      }, ` ` + allOption.label);
    }
  }
  return /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      elref: `filterSelection`,
      "always-show-caret": true,
      theme: SelectTheme.MenuFilter,
      size: ButtonSize.Inline,
      sections: this.attr(`sections`),
      "menu-width": null
    },
    on: { change: this.filterChangeHandler }
  });
}
